"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'botTest.preview.title': 'Vista Previa del Test de Bot',
    'botTest.preview.run': 'Ejecutar Test',
    'botTest.preview.edit': 'Editar Test',
    'botTest.preview.back': 'Volver a la Lista',
    'botTest.preview.section.basic_info': 'Información Básica',
    'botTest.preview.section.statistics': 'Estadísticas',
    'botTest.preview.section.testers': 'Configuración de Prueba',
    'botTest.preview.not_provided': 'No proporcionado',
    'botTest.preview.total_testers': 'Total de Testers',
    'botTest.preview.total_targets': 'Total de Objetivos',
    'botTest.preview.creator': 'Creado por',
    'botTest.preview.unknown_creator': 'Desconocido',
    'botTest.preview.testers_count': 'Testers',
    'botTest.preview.targets_count': 'Objetivos',
    'botTest.preview.created_date': 'Creado',
    'botTest.preview.updated_date': 'Última actualización',
    'botTest.preview.tester_configuration': 'Configuración del Tester',
    'botTest.preview.prompt_overridden': 'Prompt sobrescrito',
    'botTest.preview.no_targets': 'No hay objetivos configurados',
    'botTest.preview.unknown_avatar': 'Avatar desconocido',
    'botTest.preview.no_testers': 'No hay Testers configurados',
    'botTest.preview.no_testers_description': 'Agregue testers para configurar los modelos de IA y prompts para pruebas.',
    'botTest.preview.not_found': 'Test de Bot no encontrado',
    'botTest.preview.not_found_description': 'El test de bot solicitado no pudo ser encontrado o ha sido eliminado.',
    'botTest.preview.no_model': 'Sin modelo',
    'botTest.preview.unknown_model': 'Modelo desconocido',
    'botTest.preview.status.unknown': 'Desconocido',
    'botTest.preview.status.active': 'Activo',
    'botTest.preview.status.inactive': 'Inactivo',
    'botTest.preview.status.standby': 'En Espera',
    'botTest.preview.status.pending': 'Pendiente',
    'botTest.preview.status.running': 'Ejecutándose',
    'botTest.preview.status.completed': 'Completado',
    'botTest.preview.status.failed': 'Falló',
    'botTest.preview.error.load_failed': 'Error al cargar el test de bot',
    'botTest.preview.run_confirmation': '¿Está seguro de que desea ejecutar este test?',
    'botTest.preview.run_started': 'Test de bot iniciado exitosamente',
    'botTest.preview.run_failed': 'Error al iniciar el test de bot',
    'botTest.preview.tabs.data': 'Datos',
    'botTest.preview.tabs.test_results': 'Resultados de pruebas',
    'botTest.preview.section.test_results': 'Resultados de pruebas',
    'botTest.preview.no_test_results': 'No hay resultados de pruebas disponibles',
    'botTest.preview.no_test_results_description': 'Ejecute la prueba de bot para ver los resultados aquí.',
    'botTest.preview.model': 'Modelo',
    'botTest.preview.temperature': 'Temperatura',
    'botTest.preview.completed': 'Completado',
    'botTest.preview.failed': 'Fallido',
    'botTest.preview.status': 'Estado',
    'botTest.preview.messages': 'Mensajes',
    'botTest.preview.tokens': 'Tokens',
    'botTest.preview.duration': 'Duración',
    'botTest.preview.total_messages': 'Total de mensajes',
    'botTest.preview.total_tokens': 'Total de tokens',
    'botTest.preview.avg_duration': 'Duración promedio',
};
